import * as React from "react";
import { ArrowRight, Phone, MapPin, Settings, HardHat, Zap, Droplets, ShieldCheck, Lightbulb } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
const services = [{
  title: "Consulting",
  description: "The Leads consultancy service contributes to a substantial part of our business with assistance and goodwill provided from the many years of experience and knowledge of the mining industry.",
  imageSrc: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_387380600-scaled.jpeg?v=8p1ibp24uum",
  imageSrcset: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_387380600-scaled.jpeg?v=31ng6g6xxqq-wvc-srcset",
  imageSizes: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_387380600-scaled.jpeg?v=j1af8sn2w-wvc-sizes",
  imageAlt: "Professional consulting services",
  link: "/services/consulting",
  icon: HardHat
}, {
  title: "Service & Maintenance",
  description: "The Leads offers a wide range of services and maintenance solutions for the products that we supply. Our team has many years of experience in Heavy Earthmoving Equipment and repairs.",
  imageSrc: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_1908594456-scaled.jpeg?v=b8l2k7fpa1c",
  imageSrcset: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_1908594456-scaled.jpeg?v=sv3mygtoup-wvc-srcset",
  imageSizes: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_1908594456-scaled.jpeg?v=7ytpn57xp2n-wvc-sizes",
  imageAlt: "Industrial service and maintenance",
  link: "/services/maintenance",
  icon: Settings
}, {
  title: "Technicians",
  description: "We provide skilled technicians to assist and train mine personnel during pump installations and after-sales support for all our major brand partners.",
  imageSrc: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_652906329-scaled.jpeg?v=11at92ibhpff",
  imageSrcset: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_652906329-scaled.jpeg?v=qms2nvjiyen-wvc-srcset",
  imageSizes: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_652906329-scaled.jpeg?v=i5v7plc15p-wvc-sizes",
  imageAlt: "Expert technicians at work",
  link: "/services/technicians",
  icon: Zap
}, {
  title: "Mining Equipment & Supplies",
  description: "A comprehensive range of high-quality underground mining equipment, pumps, and specialised tools tailored for the African mining sector.",
  imageSrc: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_858891368-scaled.jpeg?v=2zajghvalba",
  imageSrcset: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_858891368-scaled.jpeg?v=b1kecd2grn-wvc-srcset",
  imageSizes: "https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_858891368-scaled.jpeg?v=b157e9v5f3-wvc-sizes",
  imageAlt: "Mining equipment and supplies",
  link: "/services/equipment",
  icon: Droplets
}];
const categories = [{
  title: "Core Mining Equipment",
  items: ["Underground Mining Machinery", "Crushers & Vibrating Feeders"],
  icon: HardHat
}, {
  title: "Pumping & Electrical",
  items: ["High-Capacity Pumping Systems", "Industrial Piping", "Switchboards & Components"],
  icon: Zap
}, {
  title: "Supplies & Consumables",
  items: ["Welding Machinery", "Protective Coatings", "LED & Demarcation Lighting"],
  icon: Lightbulb
}, {
  title: "Support Services",
  items: ["Expert Consulting", "Routine Maintenance", "On-Site Training"],
  icon: ShieldCheck
}];
export default function ServicesShowcase() {
  return <section id="services-showcase" className="bg-background ![padding:10px_0px_0px_0px]">
      <div className="page-container">
        <div className="mb-16 text-center">
          <h2 className="mb-6 text-4xl font-black uppercase tracking-wider text-[#004654] md:text-5xl">
            Our Services
          </h2>
          <p className="mx-auto max-w-3xl text-muted-foreground !font-sans !font-medium !text-sm">AT THE LEADS, WE PROVIDE A COMPREHENSIVE RANGE OF HIGH-QUALITY MINING EQUIPMENT, OPERATIONAL SUPPLIES, AND SPECIALIZED SUPPORT SERVICES TAILORED TO THE AFRICAN MINING AND INDUSTRIAL SECTORS. OUR GOAL IS TO ENHANCE OPERATIONAL EFFICIENCY, ENSURE MAXIMUM UPTIME, AND MAINTAIN THE HIGHEST STANDARDS OF SAFETY ON-SITE.</p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {services.map((service, index) => <Card key={index} data-index={index} className="group overflow-hidden border-none shadow-lg transition-all hover:shadow-xl">
              <div className="aspect-video overflow-hidden">
                <img src={service.imageSrc} data-wvc-srcset={service.imageSrcset} data-wvc-sizes={service.imageSizes} alt={service.imageAlt} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
              </div>
              <CardHeader className="pb-2">
                <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-lg bg-[#004654]/10 text-[#004654]">
                  <service.icon className="size-5" />
                </div>
                <CardTitle className="text-xl font-bold text-[#004654]">{service.title}</CardTitle>
              </CardHeader>
              <CardContent className="flex-grow">
                <CardDescription className="text-sm leading-relaxed">
                  {service.description}
                </CardDescription>
              </CardContent>
              
            </Card>)}
        </div>

         <div>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_facility_overview.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_facility_overview.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_facility_overview.png-wvc-sizes" alt="Mining facility overview" className="object-cover !h-[400px] !w-[1000px] !p-0 ![margin:30px_0px_0px_0px]" loading="lazy" src="https://theleads.co.za/wp-content/uploads/2026/06/AdobeStock_858891368-scaled.jpeg" />
        </div>

        <div className="grid gap-8 ![margin:30px_0px_0px_0px] md:grid-cols-2">
          {categories.map((cat, idx) => <div key={idx} data-index={idx} className="flex gap-6 rounded-xl bg-secondary/30 p-8">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-[#004654] text-white">
                <cat.icon className="size-6" />
              </div>
              <div>
                <h3 className="mb-4 text-xl font-bold text-[#004654]">{cat.title}</h3>
                <ul className="space-y-2">
                  {cat.items.map((item, i) => <li key={i} className="flex items-center gap-2 text-muted-foreground">
                      <div className="h-1.5 w-1.5 rounded-lg bg-[#004654]/40" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>

        <div className="mt-16 overflow-hidden rounded-lg shadow-md">
          
        </div>

        <div className="rounded-2xl bg-[#004654] p-8 text-white ![margin:10px_0px_0px_0px] md:p-12">
          <div className="flex flex-col items-center gap-8 !justify-center md:flex-row">
            <div className="text-center md:text-left">
              <h3 className="mb-2 text-2xl font-bold !text-center">NEED A CUSTOMISED SOLUTION?</h3>
              <p className="text-white/80">GET IN TOUCH WITH OUR TECHNICAL TEAM TODAY TO DISCUSS YOUR FACILITY'S SPECIFIC REQUIREMENTS.</p>
            </div>
            <div className="flex flex-col gap-4 sm:flex-row">
              <Button variant="secondary" size="lg" className="rounded-lg" asChild>
                
              </Button>
              <Button variant="outline" size="lg" className="border-white/20 bg-transparent text-white hover:bg-white/10 rounded-lg" asChild>
                
              </Button>
            </div>
          </div>
          <div className="mt-8 border-t border-white/10 pt-8 text-center text-sm text-white/60">+27 (10) 061-1902<br />Address: Unit 2, Albert Amon Road, Meadowdale, Germiston, 1614</div>
        </div>

        <div className="mt-16 overflow-hidden rounded-lg shadow-md">
          
        </div>
      </div>
    </section>;
}